import { render, staticRenderFns, recyclableRender, components } from "./index-header.vue?vue&type=template&id=58267f38&"
var renderjs
import script from "./index-header.vue?vue&type=script&lang=js&"
export * from "./index-header.vue?vue&type=script&lang=js&"
import style0 from "./index-header.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!F:\\软件\\HBuilderX.2.3.3.20190923.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\软件\\HBuilderX.2.3.3.20190923.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58267f38')) {
      api.createRecord('58267f38', component.options)
    } else {
      api.reload('58267f38', component.options)
    }
    module.hot.accept("./index-header.vue?vue&type=template&id=58267f38&", function () {
      api.rerender('58267f38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "E:/uni_app/douyin/douyin/components/index-header.vue"
export default component.exports